<template>
  <div class="row mt-2">
    <div class="col-md-4" v-for="(item, index) in items" :key="item.id || index" v-show="items.length > 0">
      <div class="btn-group btn-block mb-1 mr-1">
        <button
          @click="changePosition(item, index)"
          :class="{'active': index == activeTab}"
          class="btn btn-sm btn-secondary">
          {{index+1}}
          </button>
        <button
          @click="changePosition(item, index)"
          class="btn btn-block btn-sm btn-outline-secondary"
          :class="{'active': index == activeTab}">
          {{ contactName(item) | firstAndLastName}}
        </button>
      </div>
    </div>

    <div class="col-md-4" v-show="items.length == 0">
      <div class="btn-group btn-block mb-1 mr-1">
        <button class="btn btn-sm btn-secondary active">0</button>
        <button class="btn btn-block btn-sm btn-outline-secondary active">SEM CONTATO</button>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "CRMTabs",

  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },

    tabName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      activeTab: 0
    };
  },

  methods: {
    changePosition(data, index) {
      this.$emit("changedTab", data);
      this.activeTab = index;
    },

    contactName(item) {
      let name = item[this.tabName] || item['telefone']
      return `${name} (#${item.id || 0})`
    }
  }
};
</script>



// WEBPACK FOOTER //
// Tabs.vue?5cc2985e